// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c1004a5c","977":"9a72b369"}[chunkId] + ".chunk.js";
};